// OUTDataType_Headless.tsx
import * as React from "react";
import "./index.css"
import { OUTDATATYPES } from './swmmreact'

// dataType: A singular integer representing the types from 
//  outputDataWords from wordsnKeys.js,
// which corresponds to :
//  outputDataUnitsWords
// onChange: The update function for the main control.
// This control is a headless control for data type objects.

interface IDataTypeHeadless {
  dataType: number,
  onChange: any
}

const OUTDataType_Headless = ({ dataType, onChange }: IDataTypeHeadless) => {
  // If the input changes, then change the parent model.
  React.useEffect(() => {
    onChange({name: 'dataType', value: dataType })
  }, [])

  return(<></>)
}
 
export {OUTDataType_Headless};